import { gql } from '@apollo/client';

export const GET_EVENT_LIST = gql`
  query EventList($input: EventsInput, $page: Int, $first: Int) {
    eventList(input: $input, page: $page, first: $first) {
      data {
        timestamp
        type
        additional_data
        additional_seconds
        description
        host {
          title
        }
        host2 {
          title
        }
        client {
          uuid
          phone
          nickname
          first_name
          last_name
        }
        worker {
          uuid
          phone
          nickname
          first_name
          last_name
        }
        role {
          id
          title
        }
        role2 {
          title
        }
        comment
        payment {
          id
          title
          value
        }
        value1
        value2
        penalty
        booking {
          cost
          from
          id
          to
        }
        hosts {
          value
          title
          id
        }
        tariff {
          id
          title
        }
        cash_order {
          type
          sum
          comment
        }
        client_session {
          elapsed
          expires_at
          finished_at
          id
          time_left
          is_per_minute
          total_cost
        }
        deposit
        duration
        combo {
          host_group_id
          host_group_title
          id
          tariff_id
          tariff_title
          title
        }
        combo_items {
          title
          price
          amount
        }
        discount {
          title
          value
        }
        good {
          title
        }
        goods {
          title
        }
        host_group {
          title
        }
        new_devices {
          alias
          value
          value2
        }
        operator {
          first_name
          last_name
        }
        role {
          title
        }
        cash_on_start
        promo_campaign {
          id
          title
          description
          value
          applicable_params
          client_scope
          scopes
          generation_settings
          counters
          active
          active_from
          active_to
          is_tracked
          created_at
          updated_at
        }
        promo_code_item {
          id
          title
          description
          value
          applicable_params
          client_scope
          scopes
          active
          active_from
          active_to
          is_tracked
          created_at
        }
        company_news_item {
          id
          image
          label
          url
          title
          active
          active_from
          active_to
          created_at
        }
        company_news_item_changes {
          id
          image
          label
          url
          title
          active
          active_from
          active_to
          created_at
        }
        service {
          title
        }
        setting {
          alias
          value
          value2
        }
        user_group {
          title
          value
        }
        user_group2 {
          title
          value
        }
        worker_task {
          title
        }
        host_command {
          title
        }
        cashback
        payment_items {
          amount
          entity_type
          sum
          title
          id
        }
        payment_transaction {
          payment_id
          uuid
        }
        manager {
          nickname
          phone
          first_name
          last_name
          uuid
        }
        warehouse_item {
          value2
          value
          title
          entity_type
        }
        send_code_method
        goods_category {
          title
        }
        advertisement {
          id
          title
        }
      }

      paginatorInfo {
        count
        currentPage
        lastPage
      }
    }
  }
`;
